import { jsx as _jsx } from "react/jsx-runtime";
import { SignInEntityContextProvider } from '../context/sign-in-entity.context';
export function withSignInEntityProvider(Component, trigger) {
    return function WithSignInEntityProvider(props) {
        return (_jsx(SignInEntityContextProvider, { trigger: trigger, children: _jsx(Component, Object.assign({}, props)) }));
    };
}
